@if (control) {
  <mat-form-field class="{{ additionalClass() }}" [floatLabel]="control.value ? 'always' : 'auto'">
    <mat-label [ngClass]="{
      'text-red': control.invalid && (control.dirty || control.touched)
    }">{{ label() }}</mat-label>
    <input
      matInput
      type="text"
      [autocomplete]="autocomplete()"
      [formControl]="control"
      [mask]="maskComputed()"
      [dropSpecialCharacters]="false"
      [pattern]="patternComputed()"
      [attr.disabled]="disabled"
      [readonly]="readonly()"
      [ngClass]="{
        'text-center': alignment() === 'center',
        'text-left': alignment() === 'left',
        'text-right': alignment() === 'right'
      }"
      (keypress)="onKeyPress($event)"
      />
      @if (startHint()) {
        <mat-hint align="start">
          <strong>{{ startHint() }}</strong>
        </mat-hint>
      }
      @if (endHint()) {
        <mat-hint align="end">
          <strong>{{ endHint() }}</strong>
        </mat-hint>
      }
      @if (showError && control.hasError('required')) {
        <mat-error [id]="''">Required</mat-error>
      }
      @if (control.hasError('pattern')) {
        <mat-error>{{ patternErrorMessageComputed() }}</mat-error>
      }
      @if (control.hasError('message')) {
        <mat-error [id]="''">{{ control.getError('message') }}</mat-error>
      }
    </mat-form-field>
  }
